var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExcelReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M726.4 260.8h140.8v76.8h-140.8v-76.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M553.6 259.2h140.8v76.8h-140.8v-76.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00753f",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeWidth: 64,
    d: "M875.2 856h-432c-35.2 0-64-28.8-64-64v-545.6c0-35.2 28.8-64 64-64h432c35.2 0 64 28.8 64 64v545.6c0 35.2-28.8 64-64 64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M724.8 368h140.8v76.8h-140.8v-76.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M553.6 368h140.8v76.8h-140.8v-76.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M553.6 476.8h140.8v76.8h-140.8v-76.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M553.6 688h140.8v76.8h-140.8v-76.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M553.6 585.6h140.8v76.8h-140.8v-76.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00753f",
    d: "M59.2 187.2l513.6-110.4v862.4l-513.6-94.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeWidth: 16,
    d: "M427.2 652.8h-48l-64-115.2-65.6 115.2h-44.8l86.4-145.6-80-136h46.4l59.2 105.6 52.8-116.8h49.6l-76.8 145.6 84.8 147.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M726.4 585.6h140.8v76.8h-140.8v-76.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M726.4 688h140.8v76.8h-140.8v-76.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a39",
    d: "M724.8 476.8h140.8v76.8h-140.8v-76.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.26,
    d: "M572.8 196.8h65.6v643.2h-65.6v-643.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcelReport);
export default __webpack_public_path__ + "static/media/iconExcelReport.a17d0a593fc33dd14eafae4af132ac6d.svg";
export { ForwardRef as ReactComponent };